import { getTeamColors } from "../../../components/colors";
import type { SubTypeId, ChalkboardEvent } from "./utils";
import { SUBTYPE } from "./utils";

const BORDER_COLOR_CLASSES = {
  success: "text-green",
  fail: "text-red",
  neutral: "text-yellow",
  highlight: "text-blue",
} as const;

export function getTeamColor(status: any, team: "home" | "away") {
  const c = getTeamColors(status);
  return team === "home" ? c.home : c.away;
}

export function toggleSubtype(prev: SubTypeId[], sub: SubTypeId): SubTypeId[] {
  return prev.includes(sub) ? prev.filter((s) => s !== sub) : [...prev, sub];
}

export function getBorderColorForEvent(e: ChalkboardEvent): string {
  if ((e as any).outcome === "success") return BORDER_COLOR_CLASSES.success;
  if ((e as any).outcome === "fail") return BORDER_COLOR_CLASSES.fail;
  if ((e as any).outcome === "other")
    return BORDER_COLOR_CLASSES.neutral;

  const blueSubs = new Set<SubTypeId>([SUBTYPE.Goals, SUBTYPE.Assists]);

  const successSubs = new Set<SubTypeId>([
    SUBTYPE.ShotOnTargets,
    SUBTYPE.SuccessfulPasses,
    SUBTYPE.SuccessfulCrosses,
    SUBTYPE.Tackles,
    SUBTYPE.DribbleSuccess,
    SUBTYPE.Saves,
    SUBTYPE.Claims,
    SUBTYPE.Punches,
    SUBTYPE.Fouls,
  ]);

  const failSubs = new Set<SubTypeId>([
    SUBTYPE.ShotOffTargets,
    SUBTYPE.UnsuccessfulPasses,
    SUBTYPE.UnsuccessfulCrosses,
    SUBTYPE.DribbleFail,
    SUBTYPE.Interceptions,
  ]);

  if (blueSubs.has(e.subtype)) return BORDER_COLOR_CLASSES.highlight;
  if (successSubs.has(e.subtype)) return BORDER_COLOR_CLASSES.success;
  if (failSubs.has(e.subtype)) return BORDER_COLOR_CLASSES.fail;
  return BORDER_COLOR_CLASSES.neutral;
}
